import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { Injectable, InjectionToken, inject } from '@angular/core';

import { SDK } from '@plugins/middleware-sdk';

export const MIN_INIT_HEIGHT = new InjectionToken<number>('MIN_INIT_HEIGHT');

@Injectable({
  providedIn: 'root',
})
export class AppGuard {
  private readonly sdk = inject(SDK);
  private readonly min = inject(MIN_INIT_HEIGHT, { optional: true });

  private initialized = false;

  canActivate(): boolean {
    if (this.initialized) {
      return true;
    }
    this.sdk.initHeightObserver({ min: this.min ?? 150 });
    registerLocaleData(localeDe);
    this.initialized = true;
    return true;
  }
}
